import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";
export var renderStartsIn = function (startsIn, kickOffTime) {
    return React.createElement(React.Fragment, null,
        React.createElement(EventCardSectionItem, { content: startsIn, className: "rj-ev-list__ev-card__start rj-ev-list__ev-card__start-in", "data-uat": "div-ev-list-ev-card-start-in" }),
        React.createElement(EventCardSectionItem, { content: kickOffTime, className: "rj-ev-list__ev-card__start rj-ev-list__ev-card__start-time", "data-uat": "div-ev-list-ev-card-start-time" }));
};
//# sourceMappingURL=renderStartsIn.js.map